import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useDistricts } from "../../../hooks";

const DistrictSelect = ({ provinceId, ...props }) => {
  const { isLevel2 } = props;
  const { t } = useTranslation(["order"]);

  const { data: districts, refetch: refetchDistricts } = useDistricts({
    countryId: 1,
    type: 2,
    parent_code: provinceId,
    record_status: isLevel2 ? "O" : "C",
  });

  useEffect(() => {
    if (provinceId) {
      refetchDistricts();
    }
  }, [provinceId, isLevel2]);

  const options = [];
  for (const key in districts) {
    options.push({
      label: districts[key],
      value: key,
    });
  }

  if (props.value && !props.value.label) {
    props.value.label = options.find(e => e.value == props.value.value)?.label;
  }

  return (
    <Select
      {...props}
      placeholder={t("placeholder.select", {
        title: isLevel2
          ? t("form.receiver_ward_code")
          : t("form.receiver_district_code"),
      })}
      options={options}
      classNamePrefix="select2-selection"
    />
  );
};
export default DistrictSelect;
